<template>
  <v-card flat class="pa-1 position-relative">
    <v-card class="pa-4 white component-v-card">
      <v-card class="ma-3 mb-4" outlined>
        <v-card-title class="py-2"><v-icon class="mr-2">mdi-filter</v-icon>Buscar clientes para editar</v-card-title>
        <v-card-text class="py-4">
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="filters.clientType" row :disabled="busy">
                <v-radio v-for="type in types" :key="type.value" :label="type.label" :value="type.value" class="mr-4" />
              </v-radio-group>
            </v-col>
          </v-row>
          
            <v-row @keyup.enter="searchCustomers()">
              <v-col v-for="field in textFilters" :key="field.name" cols="12" md="4">
                <v-text-field v-model="filters[field.name]" :label="field.label" outlined dense clearable
                  :disabled="busy" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="filters.id_class" :items="classes" item-text="name" item-value="id"
                  label="Clase" outlined dense clearable :disabled="busy" @change="classChanged" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="filters.id_category" :items="filteredCategories" item-text="name"
                  item-value="id" label="Categoría" outlined dense clearable :disabled="busy || !filters.id_class"
                  @change="filters.id_subcategory = null" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="filters.id_subcategory" :items="filteredSubcategories" item-text="name"
                  item-value="id" label="Subcategoría" outlined dense clearable
                  :disabled="busy || !filters.id_category" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="filters.Country" :items="countryOptions" item-text="label"
                  item-value="value" label="País" outlined dense clearable :disabled="busy"
                  @change="countryFilterChanged" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-if="filters.Country === 'El Salvador'" v-model="filters.Department"
                  :items="catalogOptions('Departamento')" item-text="label" item-value="value" label="Departamento"
                  outlined dense clearable :disabled="busy" @change="departmentFilterChanged" />
                <v-combobox v-else v-model="filters.Department" :items="foreignStates" label="Estado / Departamento"
                  outlined dense clearable :disabled="busy || !filters.Country || loadingStates"
                  :loading="loadingStates" @change="departmentFilterChanged" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-if="filters.Country === 'El Salvador'" v-model="filters.Municipality"
                  :items="municipalityFilterOptions" item-text="label" item-value="value" label="Municipio" outlined
                  dense clearable :disabled="busy || !filters.Department" />
                <v-combobox v-else v-model="filters.Municipality" :items="foreignCities" label="Ciudad / Municipio"
                  outlined dense clearable :disabled="busy || !filters.Department || loadingCities"
                  :loading="loadingCities" />
              </v-col>
              <v-col v-if="enableClientZones" cols="12" md="4">
                <v-autocomplete v-model="filters.ZoneClient" :items="clientZones" label="Zona del cliente" outlined
                  dense clearable :disabled="busy" />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="filters.ID_Seller" :items="filteredSellers" item-text="FullName"
                  item-value="ID_Seller" label="Vendedor" outlined dense clearable :disabled="busy" />
              </v-col>
              <v-col v-if="enableSellerZones" cols="12" md="4">
                <v-autocomplete v-model="filters.ID_SellerZone" :items="sellerZones" item-text="Name"
                  item-value="ID_SellerZone" label="Zona del vendedor" outlined dense clearable :disabled="busy"
                  @change="filters.ID_Seller = null" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="onlyErrors" label="Mostrar solo clientes con errores" :disabled="busy"
              hide-details />
              </v-col>
            </v-row>
        
          <v-row>
            <v-col cols="12" md="8">
              <v-autocomplete v-model="missingFields" :items="availableFields" item-text="label" item-value="name"
                label="Buscar clientes con campos faltantes"
                persistent-hint multiple chips small-chips deletable-chips clearable outlined dense
                :disabled="busy || !ready" />
            </v-col>
            <v-col cols="12" md="4">
              <v-btn color="primary" :loading="loading" :disabled="busy || !ready" @click="searchCustomers()"><v-icon
                  left>mdi-reload</v-icon>Buscar Clientes</v-btn>
              &nbsp;
              <v-btn color="warning" :disabled="busy" @click="clearFilters">Limpiar filtros</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      
      <template v-if="customers.length"> 
        <v-card class="ma-3 mb-4" outlined flat>
          <v-card-title class="text-subtitle-1">Edición masiva</v-card-title>
          <v-row class="ma-3">
            <v-col cols="12" md="5">
              <v-autocomplete v-model="massField" :items="availableFields" item-text="label" item-value="name"
                label="Campo para aplicar a todos" outlined dense clearable :disabled="busy" @change="massValue = ''" />
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete v-if="massOptions !== null" v-model="massValue" :items="massOptions" item-text="label"
                item-value="value" label="Valor" outlined dense :disabled="busy || !massField" />
              <v-text-field v-else v-model="massValue" label="Valor" outlined dense :disabled="busy || !massField"
                maxlength="255" />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn color="primary" outlined :disabled="busy || !massField || !String(massValue || '').trim()"
                @click="applyToAll" class="float-end"><v-icon left>mdi-check-all</v-icon>Aplicar a Todos</v-btn>
            </v-col>
          </v-row>
          <v-row class="ma-3">
            <v-col cols="12" md="6"><v-checkbox v-model="autoSave" label="Guardar automáticamente al editar una celda"
                :disabled="busy" hide-details /></v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-btn color="success" :disabled="!pendingRows.length || busy" :loading="saving"
                @click="saveChanges()"><v-icon left>mdi-content-save</v-icon>Guardar Cambios</v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-alert v-if="errorCount" type="error" outlined class="ma-3">
          Clientes con campos faltantes: <v-btn color="error" small @click="sortErrors">Errores {{ errorCount }}</v-btn>
        </v-alert>
      </template>
      <v-alert v-if="message" :type="messageType" outlined dismissible @input="message = ''" class="ma-3">{{ message
        }}</v-alert>
      <DxDataGrid ref="grid" width="100%" :data-source="visibleCustomers" key-expr="ID_Customer" :show-row-lines="true"
        :show-borders="true" :row-alternation-enabled="true" :column-auto-width="true" :word-wrap-enabled="true"
        :repaint-changes-only="true" @exporting="onExporting" @cell-prepared="onCellPrepared">
        <DxExport :enabled="true" />
        <DxScrolling row-rendering-mode="virtual" column-rendering-mode="virtual" />
        <DxPaging :page-size="20" />
        <DxColumn data-field="ID_Customer" caption="ID Cliente" :width="140" :fixed="true" />
        <DxColumn caption="Estado" cell-template="status" :width="90" />
        <DxColumn v-for="field in availableFields" :key="field.name" :data-field="field.name" :caption="field.label" :width="230"
          cell-template="editable" />
        <template #editable="{ data }">
          <div v-if="applies(fieldByName(data.column.dataField), data.data)">
            <v-autocomplete v-if="optionsFor(data.column.dataField, data.data) !== null"
              :value="editorValue(data.data, data.column.dataField)"
              :items="optionsFor(data.column.dataField, data.data)" item-text="label" item-value="value"
              :error="isMissing(data.data, data.column.dataField)" :aria-label="data.column.caption" :disabled="busy"
              dense hide-details outlined @change="editValue(data.data, data.column.dataField, $event)" />
            <v-text-field v-else :value="data.data[data.column.dataField]"
              :error="isMissing(data.data, data.column.dataField)" :aria-label="data.column.caption" :disabled="busy"
              dense hide-details outlined maxlength="255"
              @change="editValue(data.data, data.column.dataField, $event)" />
          </div>
          <span v-else class="grey--text">No aplica</span>
        </template>
        <template #status="{ data }">
          <v-icon v-if="hasChanges(data.data)" color="warning" title="Cambios pendientes">mdi-pencil</v-icon>
          <v-icon v-else-if="updatedIds.includes(data.data.ID_Customer)" color="success"
            title="Actualizado">mdi-check-circle</v-icon>
        </template>
      </DxDataGrid>
      <v-alert v-if="searched && !customers.length" type="info" outlined class="ma-3">No se encontraron clientes con
        estos
        filtros.</v-alert>
      <v-alert v-if="searched && customers.length && onlyErrors && !visibleCustomers.length" type="success" outlined
        class="ma-3">
        No hay clientes con errores ni cambios pendientes por revisar.
      </v-alert>
      <v-alert v-if="customers.length" type="info" outlined class="ma-3">
        Clientes encontrados: {{ customers.length }} · Modificados (pendientes): {{ pendingRows.length }} ·
        Actualizados: {{
          updatedIds.length }}
      </v-alert>
    </v-card>
    <v-dialog v-model="discardDialog" max-width="480" persistent>
      <v-card>
        <v-card-title>Cambios pendientes</v-card-title>
        <v-card-text>Hay cambios sin guardar. Si realiza otra búsqueda, se descartarán.</v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="discardDialog = false">Cancelar</v-btn><v-btn color="primary"
            @click="discardDialog = false; searchCustomers(true)">Descartar y buscar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { DxDataGrid, DxColumn, DxScrolling, DxPaging, DxExport } from 'devextreme-vue/data-grid';
import { mapGetters } from 'vuex';
import locationDistrict from '@/mixins/locationDistrict';
import { printToExcel } from '@/helpers/printToexcel';

export default {
  name: 'CustomersBulkEdit',
  components: { DxDataGrid, DxColumn, DxScrolling, DxPaging, DxExport },
  mixins: [locationDistrict],
  data() {
    const user = JSON.parse(localStorage.getItem('user') || '{}') || {};
    return {
      enableClientZones: Number(user.enablezoneconfiguration) === 1,
      enableSellerZones: Number(user.enablesellerzoneconfiguration) === 1,
      filters: { clientType: 'natural', ID_Customer: '', FirstName: '', LastName: '', id_class: null, id_category: null, id_subcategory: null, Country: null, Department: null, Municipality: null, ZoneClient: null, ID_SellerZone: null, ID_Seller: null },
      types: [{ value: 'all', label: 'Todos' }, { value: 'natural', label: 'Clientes naturales' }, { value: 'business', label: 'Negocios' }, { value: 'ong', label: 'ONGs' }, { value: 'public', label: 'Instituciones Públicas' }],
      textFilters: [{ name: 'ID_Customer', label: 'Id de cliente' }, { name: 'FirstName', label: 'Nombre' }, { name: 'LastName', label: 'Apellido' }],
      fields: [], missingFields: [], customers: [], originals: {}, updatedIds: [],
      classes: [], categories: [], subcategories: [],
      clientZones: [], sellerZones: [], sellers: [], foreignStates: [], foreignCities: [],
      loadingStates: false, loadingCities: false, stateRequest: 0, cityRequest: 0,
      ready: false, loading: false, saving: false, searched: false, onlyErrors: false, autoSave: false,
      countryAutoSelected: false,
      message: '', messageType: 'error', massField: null, massValue: '', discardDialog: false,
    };
  },
  computed: {
    ...mapGetters(['getCatalogMH']),
    busy() { return this.loading || this.saving; },
    filteredCategories() { return this.categories.filter(item => String(item.id_class) === String(this.filters.id_class)); },
    filteredSubcategories() { return this.subcategories.filter(item => String(item.id_cat) === String(this.filters.id_category)); },
    municipalityFilterOptions() { return this.optionsFor('Municipality', this.filters); },
    filteredSellers() { return this.sellers.filter(seller => !this.enableSellerZones || !this.filters.ID_SellerZone || String(seller.ID_SellerZone) === String(this.filters.ID_SellerZone)); },
    countryOptions() {
      const countries = this.$store.getters.getCountries;
      return Array.isArray(countries) ? countries.map(item => ({ label: item.name, value: item.name })) : [];
    },
    pendingRows() { return this.customers.filter(row => this.hasChanges(row)); },
    // Evaluate current values and preserve the complete in-memory draft.
    // A row remains visible while it has errors or unsaved changes, so a
    // corrected row can still be reviewed before saving.
    visibleCustomers() {
      return this.onlyErrors
        ? this.customers.filter(row => this.rowHasErrors(row) || this.hasChanges(row))
        : this.customers;
    },
    availableFields() {
      return this.fields.filter(field => this.fieldAppliesToClientType(field, this.filters.clientType));
    },
    errorCount() { return this.customers.filter(row => this.rowHasErrors(row)).length; },
    massOptions() { return this.optionsFor(this.massField, null); },
  },
  watch: {
    countryOptions: {
      immediate: true,
      handler(options) {
        if (this.countryAutoSelected || this.filters.Country || !options.length) return;
        const defaultCountry = options.find(option => option.value === 'El Salvador');
        if (!defaultCountry) return;
        this.countryAutoSelected = true;
        this.filters.Country = defaultCountry.value;
        this.countryFilterChanged();
      },
    },
    'filters.clientType'() {
      const availableNames = new Set(this.availableFields.map(field => field.name));
      this.missingFields = this.missingFields.filter(name => availableNames.has(name));
      if (this.massField && !availableNames.has(this.massField)) {
        this.massField = null;
        this.massValue = '';
      }
    },
  },
  mounted() { this.initialize(); },
  methods: {
    async initialize() {
      this.loading = true;
      try {
        const [metadata, classes, categories, subcategories, zoneConfiguration, sellerZones] = await Promise.all([
          this.$API.customers.getCustomersForBulkEdit({ metadataOnly: 1 }),
          this.$API.customersTypes.getClasses(), this.$API.customersTypes.getCategories(), this.$API.customersTypes.getSubs(),
          this.enableClientZones ? this.$API.business.getZoneConfiguration() : Promise.resolve([]),
          this.enableSellerZones ? this.$API.sellerZone.getSellerZones() : Promise.resolve([]),
        ]);
        this.fields = metadata.fields;
        this.classes = classes; this.categories = categories; this.subcategories = subcategories;
        const zones = (zoneConfiguration[0] || {}).ZoneConfiguration || '';
        this.clientZones = zones.split(' | ').map(zone => zone.trim()).filter(Boolean);
        this.sellerZones = sellerZones;
        this.sellers = metadata.sellers || [];
        this.ready = true;
      } catch (error) { this.showError(error, 'No se pudieron cargar los filtros.'); }
      finally { this.loading = false; }
    },
    classChanged() { this.filters.id_category = null; this.filters.id_subcategory = null; },
    async countryFilterChanged() {
      const request = ++this.stateRequest;
      ++this.cityRequest;
      this.filters.Department = null; this.filters.Municipality = null;
      this.foreignStates = []; this.foreignCities = []; this.loadingStates = false; this.loadingCities = false;
      if (!this.filters.Country || this.filters.Country === 'El Salvador') return;
      this.loadingStates = true;
      try {
        const states = await this.$API.general.getStates(this.filters.Country);
        if (request === this.stateRequest) this.foreignStates = states.map(state => state.name);
      } catch (error) { if (request === this.stateRequest) this.showError(error, 'No se pudieron cargar los departamentos. Puede escribir el valor.'); }
      finally { if (request === this.stateRequest) this.loadingStates = false; }
    },
    async departmentFilterChanged() {
      const request = ++this.cityRequest;
      this.filters.Municipality = null; this.foreignCities = []; this.loadingCities = false;
      if (!this.filters.Department || this.filters.Country === 'El Salvador') return;
      this.loadingCities = true;
      try {
        const cities = await this.$API.general.getCities(this.filters.Department);
        if (request === this.cityRequest) this.foreignCities = cities.map(city => city.name);
      } catch (error) { if (request === this.cityRequest) this.showError(error, 'No se pudieron cargar los municipios. Puede escribir el valor.'); }
      finally { if (request === this.cityRequest) this.loadingCities = false; }
    },
    clearFilters() {
      this.filters = { clientType: 'natural', ID_Customer: '', FirstName: '', LastName: '', id_class: null, id_category: null, id_subcategory: null, Country: null, Department: null, Municipality: null, ZoneClient: null, ID_SellerZone: null, ID_Seller: null };
      ++this.stateRequest; ++this.cityRequest;
      this.foreignStates = []; this.foreignCities = []; this.loadingStates = false; this.loadingCities = false;
      this.missingFields = [];
      if (!this.ready) this.initialize();
    },
    async searchCustomers(discard = false) {
      if (this.busy || !this.ready) return;
      if (this.pendingRows.length && !discard) { this.discardDialog = true; return; }
      this.loading = true; this.message = '';
      try {
        const response = await this.$API.customers.getCustomersForBulkEdit({
          ...this.filters,
          ZoneClient: this.enableClientZones ? this.filters.ZoneClient : null,
          ID_SellerZone: this.enableSellerZones ? this.filters.ID_SellerZone : null,
          missingFields: this.missingFields.join(','),
        });
        this.customers = response.customers;
        this.originals = {};
        this.customers.forEach(row => this.$set(this.originals, row.ID_Customer, { ...row }));
        this.updatedIds = []; this.searched = true;
      } catch (error) { this.showError(error, 'No se pudieron buscar los clientes.'); }
      finally { this.loading = false; }
    },
    fieldByName(name) { return this.fields.find(field => field.name === name); },
    fieldAppliesToClientType(field, clientType) {
      if (!field || clientType === 'all') return true;
      if (clientType === 'natural') return !['entity', 'business'].includes(field.scope);
      if (clientType === 'business') return field.scope !== 'natural';
      if (clientType === 'ong' || clientType === 'public') return !['natural', 'business'].includes(field.scope);
      return true;
    },
    applies(field, row) {
      if (!field || !row) return false;
      const entity = Number(row.Is_a_Business) === 1 || Number(row.Is_a_Ong) === 1 || Number(row.Is_a_PublicEntity) === 1;
      if (field.scope === 'natural' && entity) return false;
      if (field.scope === 'entity' && !entity) return false;
      if (field.scope === 'business' && Number(row.Is_a_Business) !== 1) return false;
      if (field.country === 'sv' && row.Country !== 'El Salvador') return false;
      if (field.country === 'foreign' && row.Country === 'El Salvador') return false;
      return true;
    },
    isMissing(row, name) {
      if (!this.missingFields.includes(name) || !this.applies(this.fieldByName(name), row)) return false;
      const value = String(row[name] == null ? '' : row[name]).trim();
      return !value || (row.Country === 'El Salvador' && ['District', 'Department', 'Municipality'].includes(name) && value === '00');
    },
    rowHasErrors(row) { return this.missingFields.some(name => this.isMissing(row, name)); },
    changesFor(row) {
      const original = this.originals[row.ID_Customer] || {};
      const changes = {};
      this.fields.forEach(field => {
        if (String(row[field.name] == null ? '' : row[field.name]) !== String(original[field.name] == null ? '' : original[field.name])) changes[field.name] = String(row[field.name] == null ? '' : row[field.name]);
      });
      const locationFields = ['Country', 'Department', 'Municipality', 'District'];
      if (locationFields.some(name => name in changes)) {
        locationFields.forEach(name => { changes[name] = String(row[name] == null ? '' : row[name]); });
      }
      return changes;
    },
    hasChanges(row) { return Object.keys(this.changesFor(row)).length > 0; },
    catalogOptions(name) { return (this.getCatalogMH(name) || []).map(item => ({ label: item.Valores, value: String(item.Codigo) })); },
    optionsFor(name, row) {
      if (name === 'Country') return this.countryOptions;
      if (name === 'BusinessSector') return this.catalogOptions('TipoIngreso');
      if (name === 'CountryMH') return (this.getCatalogMH('Pais') || []).map(item => ({ label: item.Valores, value: item.Valores }));
      if (name === 'codActividad') return this.catalogOptions('ActividadEconomica');
      if (name === 'LegalTaxPayerSize') return ['PEQUEÑO', 'MEDIANO', 'GRANDE'].map(value => ({ label: value, value }));
      if (name === 'LegalEntity') return (row && row.Country === 'El Salvador' ? ['PERSONA NATURAL', 'PERSONA JURÍDICA'] : ['PERSONA NATURAL', 'PERSONA JURÍDICA', 'SOCIEDAD ANÓNIMA', 'CORPORACIÓN']).map(value => ({ label: value, value }));
      if (name === 'District') return this.getDistrictOptions('El Salvador', row && row.Department, row && row.Municipality).map(item => ({ label: item.label, value: item.DistritoKey }));
      if (name === 'Department' && row && row.Country === 'El Salvador') return this.catalogOptions('Departamento');
      if (name === 'Municipality' && row && row.Country === 'El Salvador') return (this.getCatalogMH('Municipio') || []).filter(item => String(item.Departamento) === String(row.Department)).map(item => ({ label: item.Valores, value: String(item.Codigo) }));
      return null;
    },
    editorValue(row, name) {
      if (name === 'District') {
        const district = this.getDistrictByGeoCodes(row.Department, row.Municipality, row.District);
        return district ? district.DistritoKey : row.District;
      }
      return row[name] == null ? '' : String(row[name]);
    },
    exportReferenceValue(name, row, value) {
      if (value == null || value === '') return value;

      if (name === 'District' && row && row.Country === 'El Salvador') {
        const districtCode = String(value).split('-').pop();
        const district = this.getDistrictByGeoCodes(row.Department, row.Municipality, districtCode);
        return district ? district.label : value;
      }

      const options = this.optionsFor(name, row);
      const option = options && options.find(item => String(item.value) === String(value));
      return option ? option.label : value;
    },
    setValue(row, name, value) {
      this.$set(row, name, String(value == null ? '' : value).trim());
      if (name === 'Country') { row.Department = ''; row.Municipality = ''; row.District = ''; }
      if (name === 'Department') { row.Municipality = ''; row.District = ''; }
      if (name === 'Municipality') row.District = '';
      if (name === 'District') {
        this.syncLocationFromDistrict(row, 'Country', 'Department', 'Municipality', 'District');
        row.District = String(row.District).split('-').pop();
      }
      if (name === 'codActividad') {
        const activity = (this.getCatalogMH('ActividadEconomica') || []).find(item => String(item.Codigo) === String(value));
        row.descActividad = activity ? activity.Valores : '';
      }
    },
    async editValue(row, name, value) {
      if (this.busy) return;
      if (String(row[name] == null ? '' : row[name]) === String(value == null ? '' : value).trim()) return;
      this.setValue(row, name, value);
      // Preserve edits applied to all until the user explicitly saves them.
      if (this.autoSave && this.hasChanges(row)) await this.saveChanges([row]);
    },
    applyToAll() {
      const field = this.fieldByName(this.massField);
      // Take a snapshot before mutating rows because the visible list can
      // change immediately when a row becomes complete.
      const rows = this.visibleCustomers.slice();
      let count = 0;
      rows.forEach(row => {
        if (this.applies(field, row)) { this.setValue(row, field.name, this.massValue); count++; }
      });
      this.autoSave = false;
      this.messageType = 'info'; this.message = `Se aplicó el valor a ${count} clientes. Presione "Guardar Cambios" para confirmar.`;
      this.$nextTick(() => {
        if (this.$refs.grid && this.$refs.grid.instance) this.$refs.grid.instance.refresh();
      });
    },
    async saveChanges(rows) {
      if (this.busy) return;
      const pending = (rows || this.pendingRows).filter(row => this.hasChanges(row));
      if (!pending.length) return;
      this.saving = true; this.message = '';
      try {
        const payload = pending.map(row => {
          const changes = this.changesFor(row);
          const original = {};
          Object.keys(changes).forEach(name => { original[name] = this.originals[row.ID_Customer][name]; });
          return { ID_Customer: row.ID_Customer, changes, original };
        });
        const response = await this.$API.customers.updateCustomersBulk({ customers: payload });
        response.customers.forEach(saved => {
          const row = this.customers.find(item => item.ID_Customer === saved.ID_Customer);
          Object.keys(saved).forEach(name => this.$set(row, name, saved[name]));
          this.$set(this.originals, row.ID_Customer, { ...row });
          if (!this.updatedIds.includes(row.ID_Customer)) this.updatedIds.push(row.ID_Customer);
        });
        this.messageType = 'success'; this.message = `Se guardaron ${response.updated} clientes.`;
        this.$emit('saved');
      } catch (error) { this.showError(error, 'No se pudieron guardar los cambios. Los cambios quedan pendientes.'); }
      finally { this.saving = false; }
    },
    sortErrors() { this.customers.sort((a, b) => Number(this.rowHasErrors(b)) - Number(this.rowHasErrors(a))); },
    onCellPrepared(event) {
      if (event.rowType !== 'data') return;
      const name = event.column.dataField;
      event.cellElement.style.backgroundColor = this.isMissing(event.data, name) ? '#ffebee' : (name && name in this.changesFor(event.data) ? '#fff9c4' : '');
    },
    onExporting(event) {
      event.cancel = true;
      printToExcel(event, 'Edición masiva de clientes', null, '', true, true, null, {
        customizeCell: ({ gridCell, excelCell }) => {
          if (gridCell.rowType !== 'data' || !gridCell.column || !gridCell.column.dataField) return;
          const fieldName = gridCell.column.dataField;
          const rawValue = gridCell.value == null ? gridCell.data[fieldName] : gridCell.value;
          excelCell.value = this.exportReferenceValue(fieldName, gridCell.data, rawValue);
        },
      });
    },
    showError(error, fallback) {
      this.messageType = 'error';
      this.message = (error.response && error.response.data && error.response.data.message) || fallback;
    },
  },
};
</script>
